import { Component, OnInit} from '@angular/core';
import { E5coreUiSelectFromListBaseComponent } from './e5core-ui-select-from-list-base';

@Component({
  selector: 'e5core-ui-select-from-list-material',
  templateUrl: './e5core-ui-select-from-list-material.component.html',
  styleUrls: ['./e5core-ui-select-from-list-material.component.css']
})
export class E5coreUiSelectFromListMaterialComponent extends E5coreUiSelectFromListBaseComponent implements OnInit{

	constructor() {
		super();
	}

	ngOnInit() {
	}
}